import * as React from "react";

function SvgBBiconsFo(props) {
  return (
    <svg viewBox="0 0 200 200" {...props}>
      <g data-name="Obecn\xE9 ikony">
        <path
          d="M100 15.41a39.15 39.15 0 1039.16 39.15A39.15 39.15 0 00100 15.41zM72.29 93c-23.54 6.17-40.1 22.1-40.1 56.5 0 46.83 135.62 46.83 135.62 0 0-34.38-16.54-50.32-40.07-56.5a46.83 46.83 0 01-55.45 0z"
          data-name="Fyzicka osoba"
        />
      </g>
    </svg>
  );
}

export default SvgBBiconsFo;
